import api from '../api/project-api';

export default {
    applyProject(param) {
        return new Promise((resolve, reject) => {
            api.applyProject(param).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getProjectList() {
        return new Promise((resolve, reject) => {
            api.getProjectList().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    getLoginUserProjects() {
        return new Promise((resolve, reject) => {
            api.getLoginUserProjects().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    getAdminProjects() {
        return new Promise((resolve, reject) => {
            api.getAdminProjects().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    del(projectId) {
        return new Promise((resolve, reject) => {
            api.del(projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    save(data) {
        return new Promise((resolve, reject) => {
            api.save(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    update(projectId, name) {
        return new Promise((resolve, reject) => {
            api.update(projectId, name).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    review(id, reviewStatus) {
        return new Promise((resolve, reject) => {
            api.review(id, reviewStatus).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getTestProject () {
        return new Promise((resolve, reject) => {
            api.getTestProject().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    addProject (formData) {
        return new Promise((resolve, reject) => {
            api.addProject(formData).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    updateProjectSet(projectId, data){
        return new Promise((resolve, reject) => {
            api.updateProjectSet(projectId, data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    switchToFree(projectId){
        return new Promise((resolve, reject) => {
            api.switchToFree(projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getSystemProjectList(){
        return new Promise((resolve, reject) => {
            api.getSystemProjectList().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    getAdminProjectList(){
        return new Promise((resolve, reject) => {
            api.getAdminProjectList().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    }
}